export function isScheduleSelectable(schedule, lockDataById) {
    const lockData = lockDataById?.[schedule?._id]
    if (!lockData || typeof lockData !== "object") return false
    return !(lockData.isLocked || lockData.inCurrentProject)
}
